import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import * as intlTelInput from 'intl-tel-input';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { UtilityService } from '@ecap3/core';

@Component({
	selector: 'app-custom-phone-number-control',
	templateUrl: './custom-phone-number-control.component.html',
	styleUrls: ['./custom-phone-number-control.component.scss'],
})

export class CustomPhoneNumberControlComponent implements OnInit, AfterViewInit, OnDestroy { 
	@Input() isRequired = false;
	@Input() set isDisabled (value: boolean){
		this.setDisabledState(value);
	}
	@Input() label = 'Phone Number';
	@Input() placeholder = '';
	@Input() invalidErrorMessage = "Invalid Phone Number";
	@Input() control: UntypedFormControl = new UntypedFormControl()
	@Input() defaultCountryISOCode = 'CH';
	inputElId = ''
	iti: intlTelInput.Plugin;
	selectedCountryData: intlTelInput.CountryData;
	inputField:UntypedFormControl = new UntypedFormControl();
	unsubscribe$ = new Subject<void>();

	constructor(
		private cdr: ChangeDetectorRef,
		private utilityService: UtilityService
	){
		this.inputElId = this.utilityService.getNewGuid()
	}

	ngOnInit(): void {
		// console.log('is required?', this.isRequired)
		this.isDisabled && this.inputField.disable();
		if(this.isRequired){
			this.inputField.setErrors({'required': true})
			this.control.setErrors({'required': true})
		}
		this.control.valueChanges.pipe(takeUntil(this.unsubscribe$),distinctUntilChanged()).subscribe({
			next: (value) => {
				this.setInitialPhoneNumberForEditMode(value)
			}
		})
		
	}
	
	setInitialPhoneNumberForEditMode(value: string){
		const phoneNumber = value;
		let initialPhoneNumber = '';
		if(phoneNumber){
			initialPhoneNumber = phoneNumber;
			this.inputField.setValue(initialPhoneNumber);
			this.iti.setNumber(initialPhoneNumber);
			this.control.setValue(initialPhoneNumber)
			// this.inputField.setValue(this.iti.getNumber(intlTelInputUtils.numberFormat.E164));
			this.selectedCountryData = this.iti.getSelectedCountryData();
			// valueChangesSubscription && valueChangesSubscription.unsubscribe();
		}else {
			// this.iti.setNumber(`+${this.iti.getSelectedCountryData().dialCode}`);
			this.iti.setNumber(`+${this.iti.getSelectedCountryData().dialCode}`);
			// this.inputField.setValue('');
			this.iti.setCountry(this.defaultCountryISOCode);
			this.cdr.detectChanges();
		}
	}

	ngAfterViewInit() {
		// this.setDisabledState(this.isDisabled);
			setTimeout(() => {
			  const inputEl = document.getElementById(`${this.inputElId}`);
			  if(inputEl) {
				// const iti = intlTelInput(inputEl, {
				this.iti = intlTelInput(inputEl, {
				  initialCountry: "CH",
				  separateDialCode: false,
				  utilsScript: "utils.js",
					nationalMode: false,
					autoInsertDialCode: true,
				//   hiddenInput: 'full',
				// utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
				  customPlaceholder: (_: string, __: intlTelInput.CountryData): string | undefined=>{
					return this.placeholder
				  },
				})
				this.setInitialPhoneNumberForEditMode(this.control.value)

				this.inputField.valueChanges.pipe( takeUntil(this.unsubscribe$)).subscribe({
					next: (value) => {
						const hasError = !this.iti.isValidNumber();
						this.selectedCountryData = this.iti.getSelectedCountryData();
						// console.log('### hasError', hasError)
						this.control.markAsTouched();
						switch (hasError) {
							case true:
								if( value || (!value && this.isRequired)){
									// console.log('has error');
									this.inputField.setErrors({'invalid-number': true});
									this.control.setErrors({'invalid-number': true})
									break;
								}
								this.inputField.setErrors(null);
								this.control.setErrors(null);
								this.control.setValue('');
								// console.log('iti', this.iti.getNumber());

								break;
							default:
								// console.log('no error');
								this.inputField.setErrors(null);
								this.control.setValue(this.iti.getNumber(intlTelInputUtils.numberFormat.E164))
								this.control.setErrors(null);
						}
					}
				})
			  }
			})
	}
	onCountryChange(event){
		const newCountryCode: intlTelInput.CountryData = this.iti.getSelectedCountryData()
		// console.log('newCountryCode', newCountryCode)
			if(this.selectedCountryData && this.selectedCountryData.name !== newCountryCode.name && !this.iti.isValidNumber()){
				console.log('### selectedCountryData',this.selectedCountryData );
				const newPhoneNumber = this.iti.getNumber();
				// console.log('iti', newPhoneNumber);
				this.inputField.setValue(newPhoneNumber);
				// this.inputField.reset()
				// this.control.setValue(newPhoneNumber);
				this.inputField.markAsDirty();
				this.control.markAsDirty();
				this.cdr.detectChanges();
				// console.log('inputfield', this.inputField);
				// console.log('controlFiled', this.control);
				// this.control.reset()
			}
	}

	onKeyPress(event: KeyboardEvent) {
		const isCtrl = event.key==='ctrl'
		if(!isCtrl){
			if((isNaN(Number(event.key)) && event.key !== 'Backspace') && event.key!=='+'){
				return false;
			}
			return true;
		}
	}

	setDisabledState(isDisabled: boolean = false) {
		if (isDisabled) {
			this.inputField.disable();
			this.control.disable();
			return;
		}
		this.inputField.enable();
		this.control.enable();
	}

	ngOnDestroy() {
		this.iti.destroy()
		this.unsubscribe$.next(null as any);
		this.unsubscribe$.complete();
	}
}
